import React, { useEffect } from 'react';
import { Page, Header, Content } from '@backstage/core-components';
import { 
    CatalogTable,
    CatalogTableRow,
    CatalogTableColumnsFunc,
 } from '@backstage/plugin-catalog';
 
import {
  CatalogFilterLayout,
  EntityListProvider,
  useEntityList,
  EntityKindFilter as EntityKindFilterClass,
} from '@backstage/plugin-catalog-react';

import type { TableColumn, TableProps } from '@backstage/core-components';


const SetKindToSystem = () => {
  const { updateFilters } = useEntityList();

  useEffect(() => {
    updateFilters(prev => ({
      ...prev,
      kind: new EntityKindFilterClass('system', 'System'),
    }));
  }, [updateFilters]);

  return null;
};

const systemColumns: CatalogTableColumnsFunc = ctx => {
  const defaults = CatalogTable.defaultColumnsFunc(ctx) as unknown as TableColumn<CatalogTableRow>[];

  if (ctx.filters.kind?.value !== 'system') {
    return defaults;
  }

  const nameCol = CatalogTable.columns.createNameColumn();

  const columns: TableColumn<CatalogTableRow>[] = [
    {
      title: nameCol.title ?? 'Name',
      field: 'entity.metadata.name',
      render: (row) => nameCol.render?.(row, 'row') as any,
// render: (row: any) => (
//   <RouterLink to={`/catalog/${row.entity.metadata.namespace ?? 'default'}/system/${row.entity.metadata.name}`}>
//     {row.entity.metadata.title ?? row.entity.metadata.name}
//   </RouterLink>
// ),
      width: '300px',
      cellStyle: {
        fontWeight: 700,
        maxWidth: '300px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
    {
      title: 'Description',
      field: 'entity.metadata.description',
      cellStyle: {
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: '1.4',
      },
      render: row => row.entity?.metadata?.description ?? '—',
    },
  ];
  return columns;
};

const noActions: TableProps<CatalogTableRow>['actions'] = [];

export const SystemsCatalogNoFiltersPage = () => (
  <Page themeId="home">
    <Header title="CausewayOne Cloud Catalog" subtitle="Browse clouds" />
    <Content>
      <EntityListProvider>
        {/* ✅ Force kind=system without showing any UI */}
        <SetKindToSystem />

        <CatalogFilterLayout>
          {/* ✅ No Filters section => no left rail */}
          <CatalogFilterLayout.Content>
            <CatalogTable
              title ="All Clouds"
              columns={systemColumns as any}
              actions={noActions}
              tableOptions={{
                paging: false,
                search: false,
                sorting: true,
                padding: 'dense',
              }}
            />
          </CatalogFilterLayout.Content>
        </CatalogFilterLayout>
      </EntityListProvider>
    </Content>
  </Page>
);
